import { render } from "./HouseHoldInfo.vue?vue&type=template&id=ffc8e4be"
import script from "./HouseHoldInfo.vue?vue&type=script&lang=js"
export * from "./HouseHoldInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__